import { Check, X } from "lucide-react";

interface PricingFeatureListProps {
  features: string[];
  restrictedFeatures?: string[];
  checkColor?: string;
}

export const PricingFeatureList = ({ 
  features, 
  restrictedFeatures = [], 
  checkColor = "text-gray-500" 
}: PricingFeatureListProps) => {
  return (
    <ul className="space-y-4">
      {features.map((feature, index) => (
        <li key={index} className="flex items-start gap-3">
          <Check className={`h-5 w-5 mt-0.5 flex-shrink-0 ${checkColor}`} />
          <span className="text-gray-600 text-base">{feature}</span>
        </li>
      ))}
      {restrictedFeatures.map((feature, index) => (
        <li key={`restricted-${index}`} className="flex items-start gap-3 opacity-50">
          <X className="h-5 w-5 mt-0.5 flex-shrink-0 text-red-500" />
          <span className="text-gray-600 text-base">{feature}</span>
        </li>
      ))}
    </ul>
  );
};